<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Regulamento</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">
              Regulamento
           </h3>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
              <regulament></regulament>
            </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Regulament from "./partials/crazy-card/CrazyRegulament";

export default {
  name: "CrazyRegulament",
  components: {
    Regulament
  }
};
</script>
